import isNil from 'lodash.isnil';
import isEmpty from 'lodash.isempty';
import { getUrlParams } from './urlUtils';
import { SS_NAV_TABS_DATA } from '../../features/studentSummary/shared/studentSummaryNavigation/studentSummaryNavTabs';

const viewsWithPeriods = ['benchmark'];
const viewsWithoutPeriods = ['instruction', 'studentSummary'];
const intercomAppId = 'l71howyu';

export const getIntercomAppId = () =>
    intercomAppId.startsWith('{creds') ? process.env.REACT_APP_INTERCOM_APP_ID : intercomAppId;

export const getReportType = ({ pathname }, views) => {
    const currentPage = Object.keys(views).find(page => pathname.includes(page));

    return !isNil(currentPage) && views[currentPage].menuItemName;
};

export const getReportSubtype = ({ search, pathname }) => {
    const { instructionTab } = getUrlParams({ search });
    const subType = Object.keys(SS_NAV_TABS_DATA).find(page => pathname.includes(page));

    if (subType) {
        return SS_NAV_TABS_DATA[subType].title;
    }

    return instructionTab || '';
};

export const getReportPeriod = ({ pathname }, { selectedPeriod, selectedPeriodWithoutSummary }) => {
    if (viewsWithoutPeriods.some(view => pathname.includes(view))) {
        // should send empty field in Intercom
        return '';
    }
    if (viewsWithPeriods.some(view => pathname.includes(view))) {
        return selectedPeriod;
    }
    return selectedPeriodWithoutSummary;
};

export const getRootInstitutionsInfo = rootInstitutions => ({
    institutionsIds: isEmpty(rootInstitutions)
        ? ''
        : rootInstitutions.map(({ uid }) => uid).join(', '),
    institutionNames: isEmpty(rootInstitutions)
        ? ''
        : rootInstitutions.map(({ name }) => name).join(', '),
});

export const getIntercomLicensingInfo = products => (isEmpty(products) ? '' : products.join(', '));
